// import styles from "./NoPage.module.scss";
import React from "react";
// import travolta from "./confused-john-travolta.gif";
// import logo from "../../assets/recode_pro-logo-1.svg";

function NoPage() {
  return (
    <>
      {/* <img src={logo} className={styles.logo} alt="logo" /> */}
      <h1>404</h1>
      <p>Página não encontrada!</p>
      {/* <img className={styles.travolta} src={travolta} alt="Travolta confuso" /> */}
    </>
  );
}

export default NoPage;
